import { SocialLink } from '../types';

export const socialLinks: SocialLink[] = [
  // ─── Art ───
  { id: 'instagram-art', platform: 'Instagram', url: 'https://www.instagram.com/Kynothan/', icon: '/img/instagram.svg', category: 'art' },
  { id: 'youtube-art', platform: 'YouTube', url: 'https://www.youtube.com/@kynothan', icon: '/img/youtube.svg', category: 'art' },
  { id: 'tiktok-art', platform: 'TikTok', url: 'https://www.tiktok.com/@kynothan', icon: '/img/tiktok.svg', category: 'art' },
  { id: 'threads-art', platform: 'Threads', url: 'https://threads.net/@Kynothan', icon: '/img/threads.svg', category: 'art' },
  { id: 'facebook-art', platform: 'Facebook', url: 'https://www.facebook.com/kynothan34', icon: '/img/facebook.svg', category: 'art' },

  // ─── Stream ───
  { id: 'twitch', platform: 'Twitch', url: 'https://www.twitch.tv/kynothan', icon: '/img/twitch.svg', category: 'stream' },
  { id: 'instagram-stream', platform: 'Instagram VOD', url: 'https://www.instagram.com/Kynothanvod/', icon: '/img/instagram.svg', category: 'stream' },
  { id: 'youtube-stream', platform: 'YouTube VOD', url: 'https://www.youtube.com/@kynothanvod', icon: '/img/youtube.svg', category: 'stream' },
  { id: 'youtube-replay', platform: 'YouTube Replay', url: 'https://www.youtube.com/@KynothanReplay', icon: '/img/youtube.svg', category: 'stream' },
  { id: 'tiktok-stream', platform: 'TikTok VOD', url: 'https://www.tiktok.com/@kynothanvod', icon: '/img/tiktok.svg', category: 'stream' },
  { id: 'facebook-stream', platform: 'Facebook Stream', url: 'https://www.facebook.com/kynothanvod', icon: '/img/facebook.svg', category: 'stream' },
  { id: 'threads-stream', platform: 'Threads Stream', url: 'https://www.threads.com/@kynothanvod', icon: '/img/threads.svg', category: 'stream' },

  // ─── Music ───
  { id: 'spotify', platform: 'Spotify', url: 'https://open.spotify.com/artist/3n6Rbc3WXl82wNeUpoBqrV', icon: '/img/spotify.svg', category: 'music' },
  { id: 'soundcloud', platform: 'SoundCloud', url: 'https://soundcloud.com/kynothan', icon: '/img/soundcloud.svg', category: 'music' },

  // ─── Community ───
  { id: 'discord', platform: 'Discord', url: 'https://discord.gg/k6yEUBAvWw', icon: '/img/discord.svg', category: 'community' },
  { id: 'x', platform: 'X / Twitter', url: 'https://twitter.com/Kynothan', icon: '/img/x.svg', category: 'community' },
  { id: 'github', platform: 'GitHub', url: 'https://github.com/Kynothan', icon: '', category: 'community' },
];

export const heroSocials = ['instagram-art', 'twitch', 'tiktok-art', 'youtube-art', 'spotify', 'discord'];
export const heroStreamSocials = ['instagram-stream', 'twitch', 'tiktok-stream', 'youtube-stream', 'facebook-stream', 'threads-stream', 'discord'];
export const heroArtSocials = ['instagram-art', 'twitch', 'youtube-art', 'tiktok-art', 'facebook-art', 'threads-art', 'discord'];
export const heroMusicSocials = ['spotify', 'soundcloud'];
export const heroFooterSocials = ['x'];

export const getSocialsByCategory = (category: SocialLink['category']) =>
  socialLinks.filter((l) => l.category === category);

export const getSocialById = (id: string) =>
  socialLinks.find((l) => l.id === id);
